import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertsSchedularCreateRequestDTO, AlertsSchedularDeleteRequestDTO, AlertsSchedularDTO, AlertsSchedularReadAllDTO, AlertsSchedularUpdateRequestDTO } from './schedulers.interface';
import { PaginatedDTO } from 'src/app/Common/common.interface';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { environment } from 'src/environments/environment';
import { ConfirmmodalserviceService } from 'src/app/Shared/confirm-delete-modal/confirmmodalservice.service';
import { SchedulersService } from './schedulers.service';
import { ValueListItemDTO } from 'src/app/Common/ValueListService/ValueListItem.interface';

@Component({
  selector: 'app-schedulers',
  templateUrl: './schedulers.component.html',
  styleUrls: ['./schedulers.component.css']
})
export class SchedulersComponent {
  onSchedulerTypeChange(event: ValueListItemDTO) {
    this.alertSchedularForm.controls.aFreq.patchValue(Number(event.vliDesc ?? '0'));
  }

  modalService = inject(NgbModal)
  @ViewChild('alertSchedularModalContent', { static: false }) alertSchedularModalContent!: ElementRef;
  addAlertSchedularModal!: NgbModalRef;
  private confirmModal = inject(ConfirmmodalserviceService);

  private alertSchedularService = inject(SchedulersService);
  schedularsList: AlertsSchedularDTO[] = []
  isLoading = false;
  User = inject(UserLoginService).User();


  ReadAllDTO: AlertsSchedularReadAllDTO = {
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
    softwareId: parseInt(environment.SoftwareId),


  }

  alertSchedularForm = new FormGroup({
    schedularId: new FormControl(0),
    aName: new FormControl('', [Validators.required]),
    aCode: new FormControl(''),
    aFreq: new FormControl(0, [Validators.required]),
    sType: new FormControl('', [Validators.required]),
    aDesc: new FormControl(''),
    actionUser: new FormControl(''),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    softwareId: new FormControl(0),
    isActive: new FormControl(1)
  })

  ngOnInit(): void {
    this.getSchedularsList(this.ReadAllDTO);
  }
  openAlertSchedularForm() {
    this.alertSchedularForm.reset();
    this.addAlertSchedularModal = this.modalService.open(this.alertSchedularModalContent)

    this.alertSchedularForm.patchValue({
      companyId: this.User.companyId,
      branchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId),
      actionUser: this.User.userId.toString(),
    })
  }

  submitAlertSchedularForm() {
    this.alertSchedularForm.markAllAsTouched();
    if (this.alertSchedularForm.valid) {
      const formData = { ...this.alertSchedularForm.value };
      let data = {
        tenantId: formData.companyId as number,
        tenantBranchId: formData.branchId as number,
        softwareId: formData.softwareId as number,
        schedularId: formData.schedularId as number,
        frequencyInMinutes: formData.aFreq as number,
        iName: formData.aName ?? "",
        iCode: formData.aCode ?? "",
        schedularType: formData.sType ?? "",
        iDesc: formData.aDesc ?? "",
        actionUser: this.User.userId.toString(),
        isActive: 1
      };

      if (formData.schedularId && formData.schedularId !== 0) {
        this.updateSchedular(data as AlertsSchedularUpdateRequestDTO);
      } else {
        this.createSchedular(data as AlertsSchedularCreateRequestDTO);
      }
    }
  }

  updateSchedular(data: AlertsSchedularUpdateRequestDTO) {
    this.isLoading = true;
    this.alertSchedularService.AlertsSchedular_update(data).subscribe({
      next: () => {
        this.addAlertSchedularModal.close();
        this.getSchedularsList(this.ReadAllDTO);
        this.isLoading = false;
      }
    });
  }

  createSchedular(data: AlertsSchedularCreateRequestDTO) {
    this.isLoading = true;
    this.alertSchedularService.AlertsSchedular_create(data).subscribe({
      next: () => {
        this.addAlertSchedularModal.close()
        this.getSchedularsList(this.ReadAllDTO);
        this.isLoading = false;
      }
    })
  }

  getSchedularsList(data: AlertsSchedularReadAllDTO) {
    this.isLoading = true;
    this.alertSchedularService.AlertsSchedular_readAll(data).subscribe({
      next: (response) => {
        this.schedularsList = response.items;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching whatsapp config list:', err);
        this.isLoading = false;
      }
    })
  }

  handleActionClick(event: { actionName: string, rowData: AlertsSchedularDTO }) {
    const formData = event.rowData

    if (event.actionName === 'Delete') {
      this.confirmModal.openDeleteModal(formData.iName!, formData).subscribe(res => {

        if (res) {
          let data: AlertsSchedularDeleteRequestDTO = {
            schedularId: formData.schedularId,
            tenantId: formData.tenantId,
            tenantBranchId: formData.tenantBranchId,
            actionUser: this.User.userId.toString()
          };

          this.deleteSchedular(data)
        }
      })
    }
    if (event.actionName === 'Edit') {
      const data: AlertsSchedularUpdateRequestDTO = {
        ...formData,
        actionUser: this.User.userId.toString()
      };
      this.openEditModal(data);
    }
  }

  openEditModal(data: AlertsSchedularUpdateRequestDTO) {
    this.alertSchedularForm.patchValue({
      schedularId: data.schedularId,
      companyId: data.tenantId,
      branchId: data.tenantBranchId,
      softwareId: data.softwareId,
      aName: data.iName,
      aCode: data.iCode,
      aDesc: data.iDesc,
      aFreq: data.frequencyInMinutes,
      sType: data.schedularType,
      actionUser: this.User.userId.toString(),
      isActive: 1
    })
    this.addAlertSchedularModal = this.modalService.open(this.alertSchedularModalContent);
  }



  deleteSchedular(data: AlertsSchedularDeleteRequestDTO) {
    this.isLoading = true;
    this.alertSchedularService.AlertsSchedular_delete(data).subscribe({
      next: () => {
        this.getSchedularsList(this.ReadAllDTO);
        this.isLoading = false;
      }
    });
  }
  // handlePageSizeChange(event: { currentPage: number; pageSize: number; }) {
  //   const { currentPage, pageSize } = event

  //   this.PaginatedDTO = {
  //     companyId: this.User.companyId,
  //     branchId: this.User.loggedInBranchId,
  //     softwareId: parseInt(environment.SoftwareId),

  //     pageNo: currentPage,
  //     pageSize: pageSize,

  //   }
  //   this.getSchedularsList(this.PaginatedDTO)

  // }









}
